import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
export default function () {
  return <section id="mediapublicationsplaceholder" className="relative bg-background text-foreground py-20 md:py-28 lg:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
      backgroundImage: "radial-gradient(circle at 12% 18%, hsl(215 50% 15%) 0%, transparent 1.5%), radial-gradient(circle at 78% 32%, hsl(215 50% 15%) 0%, transparent 1.2%), radial-gradient(circle at 35% 70%, hsl(215 50% 15%) 0%, transparent 1.8%), radial-gradient(circle at 88% 85%, hsl(215 50% 15%) 0%, transparent 1.4%), radial-gradient(circle at 50% 50%, hsl(215 50% 15%) 0%, transparent 1%)"
    }} />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 mb-16 md:mb-24">
          {}
          <div className="lg:col-span-7">
            <p className="font-mono text-[0.75rem] uppercase tracking-[0.18em] text-secondary mb-6">
              メディア・掲載実績
            </p>
            <h2 className="font-serif font-normal text-foreground leading-[1.02] tracking-[-0.02em]" style={{
            fontSize: "clamp(2.5rem, 5.4vw, 4.75rem)"
          }}>
              メディア出演・専門誌掲載
            </h2>
            {}
            <div className="mt-8 flex items-center">
              <span className="h-px w-16 bg-foreground" />
              <span className="ml-2 h-1.5 w-1.5 rounded-lg bg-secondary" />
            </div>
          </div>

          {}
          <div className="lg:col-span-5 lg:pt-4">
            <p className="font-serif italic text-foreground/80 leading-[1.55]" style={{
            fontSize: "clamp(0.95rem, 1.1vw, 1.0625rem)"
          }}>モーリー・I・レヴィーン弁護士は、法律実務に加えて、テレビ、コマーシャル、専門誌などにも登場しています。以下は主なメディア出演・掲載実績です。</p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
          {}
          <Card className="border border-border shadow rounded-md bg-card flex flex-col justify-between overflow-hidden">
            <CardContent className="p-8">
              <div className="flex items-center justify-between mb-4">
                <span className="font-mono text-xs uppercase tracking-wider text-secondary">
                  No. 01 / Commercial
                </span>
              </div>
              <h3 className="font-serif text-2xl text-foreground mb-4 leading-snug">
                ジャガーコマーシャル出演
              </h3>
              <p className="font-sans text-foreground/80 text-base leading-relaxed mb-6">ジャガーのコマーシャルに出演した映像です。法律事務所の通常のプロフィールとは異なる、モーリー・I・レヴィーン弁護士のメディア出演実績の一つです。</p>
            </CardContent>
            <div className="px-8 pb-8 pt-0">
              <Link to="https://youtu.be/RmVQDwZtR3I" newTab className="inline-flex items-center font-sans text-sm font-medium text-primary hover:text-secondary transition-colors underline underline-offset-4">
                動画を見る（YouTube） →
              </Link>
            </div>
          </Card>

          {}
          <Card className="border border-border shadow rounded-md bg-card flex flex-col justify-between overflow-hidden">
            <CardContent className="p-8">
              <div className="flex items-center justify-between mb-4">
                <span className="font-mono text-xs uppercase tracking-wider text-secondary">
                  No. 02 / Television
                </span>
              </div>
              <h3 className="font-serif text-2xl text-foreground mb-4 leading-snug">
                テレビ出演
              </h3>
              <p className="font-sans text-foreground/80 text-base leading-relaxed mb-6">
                Channel 7 Newsのインタビューに出演した映像です。
              </p>
            </CardContent>
            <div className="px-8 pb-8 pt-0">
              <Link to="https://youtu.be/-EmVu-zcV_s" newTab className="inline-flex items-center font-sans text-sm font-medium text-primary hover:text-secondary transition-colors underline underline-offset-4">
                インタビュー映像を見る（YouTube） →
              </Link>
            </div>
          </Card>

          {}
          <Card className="border border-border shadow rounded-md bg-card flex flex-col justify-between overflow-hidden md:col-span-2 lg:col-span-2">
            <CardContent className="p-8">
              <div className="flex items-center justify-between mb-4">
                <span className="font-mono text-xs uppercase tracking-wider text-secondary">
                  No. 03 / Publication
                </span>
              </div>
              <h3 className="font-serif text-2xl text-foreground mb-4 leading-snug">
                “A Legal Roller Coaster: The Corporate Transparency Act”
              </h3>
              <p className="font-sans text-foreground/80 text-base leading-relaxed mb-6">Peter J. Guala氏とモーリー・I・レヴィーン弁護士の共著として、The Florida Bar JournalのJuly/August 2025号に掲載されたCorporate Transparency Actに関する論考です。</p>
              <div className="flex flex-wrap items-center gap-6 pt-2 border-t border-border">
                <Link to="https://www.floridabar.org/the-florida-bar-journal/a-legal-roller-coaster-the-corporate-transparency-act/" newTab className="inline-flex items-center font-sans text-sm font-medium text-primary hover:text-secondary transition-colors underline underline-offset-4">
                  公式サイトで読む（The Florida Bar Journal） →
                </Link>
                <Link to="https://probable-basilisk.10web.cloud/wp-content/uploads/2026/07/Florida-Bar-Journal-Full-Article.pdf" newTab className="inline-flex items-center font-sans text-sm font-medium text-foreground/70 hover:text-primary transition-colors underline underline-offset-4">
                  PDF版ダウンロード（予備リンク） ↓
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}